import { getLocalizedString } from "../../../shared/translation";


export const getEcoDriveReportHeaders = () => [
  {
    label: getLocalizedString("record_date", "Record Date"),
    key: "record_date",
    className: "record-date",
    type: "component",
    component: ({ data }) => {
      return (
        <span title={data?.record_date}>
          {data?.record_date}
        </span>
      );
    },
  },
  {
    label: getLocalizedString("score", "Score"),
    key: "score",
    className: "score",
    type: "component",
    component: ({ data }) => {
      const score = data?.score;
      if (score === null || score === undefined) {
        return (
          <span className="score-null" title="No score available">
            -
          </span>
        );
      }

      const scoreClass = score >= 80 ? "excellent" : score >= 60 ? "good" : score >= 40 ? "average" : "poor";
      return (
        <span className={`score-badge ${scoreClass}`} title={`Score: ${score}`}>
          {score}
        </span>
      );
    },
  },
  {
    label: getLocalizedString("point", "Point"),
    key: "point",
    className: "point",
    type: "component",
    component: ({ data }) => {
      const point = parseFloat(data?.point || 0);
      const isNegative = point < 0;
      return (
        <span
          className={isNegative ? "point-negative" : "point-positive"}
          title={`Point: ${point}`}
        >
          {point}
        </span>
      );
    },
  },
  {
    label: getLocalizedString("deducted", "Deducted"),
    key: "deducted",
    className: "deducted",
    type: "component",
    component: ({ data }) => {
      const deducted = parseFloat(data?.deducted || 0);
      return (
        <span className="deducted-value" title={`Deducted: ${deducted}`}>
          {deducted.toFixed(1)}
        </span>
      );
    },
  },
  {
    label: getLocalizedString("mileage", "Mileage (km)"),
    key: "mileage",
    className: "mileage",
    type: "component",
    component: ({ data }) => {
      const mileage = data?.mileage || 0;
      return (
        <span title={`${mileage} km`}>
          {mileage} km
        </span>
      );
    },
  },
  {
    label: getLocalizedString("harsh_acceleration", "Harsh Acceleration"),
    key: "harsh_acceleration",
    className: "harsh-acceleration",
    type: "component",
    component: ({ data }) => {
      const count = data?.harsh_acceleration || 0;
      return (
        <span className={count > 0 ? "warning-count" : "normal-count"} title={`${count} events`}>
          {count}
        </span>
      );
    },
  },
  {
    label: getLocalizedString("harsh_braking", "Harsh Braking"),
    key: "harsh_braking",
    className: "harsh-braking",
    type: "component",
    component: ({ data }) => {
      const count = data?.harsh_braking || 0;
      return (
        <span className={count > 0 ? "warning-count" : "normal-count"} title={`${count} events`}>
          {count}
        </span>
      );
    },
  },
  {
    label: getLocalizedString("harsh_turn", "Harsh Turn"),
    key: "harsh_turn",
    className: "harsh-turn",
    type: "component",
    component: ({ data }) => {
      const count = data?.harsh_turn || 0;
      return (
        <span className={count > 0 ? "warning-count" : "normal-count"} title={`${count} events`}>
          {count}
        </span>
      );
    },
  },
  {
    label: getLocalizedString("over_speed", "Over Speed"),
    key: "over_speed",
    className: "over-speed",
    type: "component",
    component: ({ data }) => {
      const count = data?.over_speed || 0;
      return (
        <span className={count > 0 ? "warning-count" : "normal-count"} title={`${count} events`}>
          {count}
        </span>
      );
    },
  },
  {
    label: getLocalizedString("idling", "Idling (min)"),
    key: "idling",
    className: "idling",
    type: "component",
    component: ({ data }) => {
      const idleMinutes = data?.idling || 0;
      return (
        <span title={`${idleMinutes} minutes`}>
          {idleMinutes} min
        </span>
      );
    },
  },
];